<template>
    <div class="inputTag" :class="{disabled:disabled}" @click="focus">
        <div class="tag" v-for="(item,index) in tagList" :key="index">
            <span class="name nowrap">{{lableKey?item[lableKey]:item}}</span>
            <i class="iconfont icon-guanbi" @click.stop="delTag(index)"></i>
        </div>
        <div class="tag__input-wrapper" v-if="!disabled">
            <input class="tag__input" ref="input" type="text" v-model="val" @keydown="keydown" />
            <div class="tag__input-calculator" :style="{maxWidth:maxWidth}">{{val}}</div>
        </div>
    </div>
</template>

<script>
export default {
    name:"inputTag",
    emits:['update:modelValue'],
    props:{
        modelValue: {
            type: Array,
            default: null
        },
        //如何数据是 json 类型数组 lableKey 表示显示的属性
        lableKey:{
            type:String,
            default:null
        },
        //禁止编辑
        disabled:{
            type:Boolean,
            default:false
        }
    },
    watch:{
        modelValue(newVal){
            this.tagList=newVal||[];
        },
        tagList(newVal){
            this.$emit('update:modelValue', newVal);
        }
    },
    data(){
        return {
            //标签数据
            tagList:[],
            val:"",
            maxWidth:'100%'
        }
    },
    methods: {
        keydown(e){
            if(e.keyCode==8 && !this.val.trim()){
                if(this.tagList.length>0){
                    this.delTag(this.tagList.length-1);
                }
            }else if(e.keyCode==13){
                this.addTag();
            }
        },
        addTag(){
            if(this.val.trim()){
                if(this.lableKey){
                    let json={};
                    json[this.lableKey]=this.val.trim();
                    this.tagList.push(json);
                }else{
                    this.tagList.push(this.val.trim());
                }
                
                this.val="";
            }
            
        },
        delTag(index){
            this.tagList.splice(index,1);
        },
        focus(){
            this.$refs.input?.focus();
            this.maxWidth= this.$el.offsetWidth+"px";
        }
    },
}
</script>

<style lang="scss">
.inputTag{
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    &.disabled{
        .tag{
            padding: 0 10px;

            .iconfont{
                display: none;
            }
        }
    }

    .tag{
        height: 26px;
        line-height: 24px;
        padding: 0 10px;
        padding-right: 5px;
        background: rgba(21, 101, 216, 0.08);
        border-radius: 26px;
        border: 1px solid #DBEAFE;
        font-weight: 400;
        font-size: 12px;
        color: #1565D8;
        display: flex;
        align-items:center;
        max-width: 100%;

        .name{
            flex:1;
        }

        .iconfont{
            display: inline-block;
            width: 18px;
            height: 18px;
            line-height: 18px;
            border-radius: 18px;
            color: #999;
            font-size: 9px;
            margin-left: 2px;
            text-align: center;
            cursor: pointer;

            &:hover{
                background-color: #999;
                color: #fff;
            }
        }
    }

    .tag__input-wrapper{
        flex: 1;
        position: relative;
        height: 26px;
        line-height: 24px;
        font-weight: 400;
        font-size: 12px;
        min-width: min-content;
        max-width: 100%;
        overflow: hidden;

        .tag__input-calculator{
            white-space: pre;
            overflow: hidden;
            visibility: hidden;
        }

        .tag__input{
            height: 26px;
            line-height: 24px;
            border: none;
            box-shadow: none;
            padding: 0;
            position: absolute;
            font-weight: 400;
            font-size: 12px;
            color: #333;
            left:0;
            top:0;
            width: 100%;
            background-color: transparent;
        }
    }
}
</style>